import { gql } from '@apollo/client';

export const userLogout = gql`
    query {
      userLogout {
          status
      }
    }
    `;

export const sendForgotPassword = gql`
    mutation sendForgotPassword($email: String!) {
      sendForgotPassword (email: $email) {
        status
        errorMessage
      }
    }
    `;

export const userAccount = `
    query userAccount{
      userAccount {
        userId
        profileId
        firstName
        lastName
        displayName
        gender
        dateOfBirth
        email
        userBanStatus
        phoneNumber
        preferredLanguage
        preferredCurrency
        location
        info
        createdAt
        picture
        country
        countryCode
        countryName
        verification {
          id
          isEmailConfirmed
          isFacebookConnected
          isGoogleConnected
          isIdVerification
          isPhoneVerified
        }
        userData {
          type
        }
      }
    }
    `;

export const getUserVerifiedInfo = gql` 
    query getUserVerifiedInfo($userId: String!) {
        getUserVerifiedInfo (userId: $userId) {
            id
            isEmailConfirmed
            isFacebookConnected
            isGoogleConnected
            isIdVerification
            status
        }
    }`;

export const updateUserVerifiedInfoMutation = gql`
    mutation updateUserVerifiedInfo($item: String!){
        updateUserVerifiedInfo(item: $item) {
            status
        }
    }
    `;

export const emailVerificationQuery = gql`
    query EmailVerification($token: String!, $email: String!){
        EmailVerification(token: $token, email: $email) {
            userId
            status 
        }
    }
    `;

export const resendConfirmEmailQuery = gql`
    query ResendConfirmEmail{
        ResendConfirmEmail {
            status
            errorMessage
        }
    }
    `;

export const userManagement = gql`
    query userManagement($currentPage: Int, $searchList: String){
        userManagement(currentPage: $currentPage, searchList: $searchList) {
          count
          usersData{
            id,
            email,
              profile {
                profileId,
                firstName,
                lastName,
                gender,
                dateOfBirth,
                phoneNumber,
                preferredLanguage,
                preferredCurrency,
                location,
                info,
                createdAt
              },
              userBanStatus,
          }
         }
      }
    `;

export const updateBanServiceHistoryStatus = gql`
    mutation($id: String, $banStatus: Int) {
      updateBanServiceHistoryStatus(id: $id ,banStatus: $banStatus){
        status
        }
      }
    `;

export const deleteUser = gql`
   mutation deleteUser ($userId:String!, $userType: String) {
      deleteUser (userId:$userId, userType: $userType) {
        status
        errorMessage
      }
    }
    `;